import React from "react"
import { graphql, Link } from "gatsby"
import styles from "@one-builder/gatsby-theme-ob-master/src/styles/global.module.scss"
import { GoTriangleRight } from "react-icons/go"

// Components
import Layout from "@one-builder/gatsby-theme-ob-master/src/components/layout/layout"
import ContactForm from "@one-builder/gatsby-theme-ob-master/src/components/contact/contact-form"
import ContactInformation from "@one-builder/gatsby-theme-ob-master/src/components/contact/contact-information"
import BackgroundImage from "gatsby-background-image"
import TestimonialSlider from "@one-builder/gatsby-theme-ob-master/src/components/home/testimonial-slider"

import { useGetTokens } from "@one-builder/gatsby-theme-ob-master/src/hooks/useGetTokens"
import convertTokens from "@one-builder/gatsby-theme-ob-master/src/helpers/convertTokens"
import setSeoData from "@one-builder/gatsby-theme-ob-master/src/helpers/setSeoData"

import { Fade } from "react-awesome-reveal"

export default ({ data, location }) => {
  // Get contact content from markdown
  const { contact } = data

  // Get metadata
  const metadata = useGetTokens()

  let heroImage
  if (contact.frontmatter.heroImage) {
    heroImage = contact.frontmatter.heroImage.childImageSharp.fluid
  }
  console.log('heroImage', contact.frontmatter)

  // If linked from service page, get selected service
  let selectedService = ""
  location.state && location.state.service
    ? (selectedService = location.state.service)
    : (selectedService = "")

  let seo_data = setSeoData(contact.frontmatter)

  return (
    <Layout location={location} seo_data={seo_data}>
      <img src="/images/contact-bg.jpg" />
      <div id={styles.contactPage} className={styles.container}>
        <h1>{contact.frontmatter.title}</h1>
        <div
          dangerouslySetInnerHTML={{
            __html: convertTokens(contact.html, metadata),
          }}
        />
      </div>
      <div className={styles.containerWide}>
        <div id={styles.contactFormSection} className={styles.flexWrapper}>
          <div id={styles.contactFormContain}>
            <ContactForm selectedService={selectedService} />
          </div>
          <ContactInformation metadata={metadata} />
        </div>
      </div>
      <section
        id={styles.testimonials}
        className={`${styles.row} ${styles.row4} ${styles.subpageTestimonials}`}
      >
        <div className={styles.container}>
          <Fade direction="down" triggerOnce={true}>
            <TestimonialSlider />
          </Fade>
        </div>
      </section>
      <section id={styles.contest} className={`${styles.row} ${styles.row5}`}>
        <div className={styles.container}>
          <div>
            <h1>Leave a Review & <strong>Enter to Win</strong></h1>
            <p>
              Who wants a tone-deaf company? Not Jim Warren and not any of the
              contractors at Warren Construction. We aim to be among the best
              handymen in Northeast Pennsylvania, and we need your help to do it.
              Your feedback helps us know what we should keep doing and where we
              can grow.
            </p>
            <p>
              In return for your time, we're offering a chance to win great
              prizes!
            </p>
          </div>
          <div
            className={styles.hpBtns}
            style={{ padding: 0, marginTop: -100 }}
          >
            <Link to="/feedback/" title="Feedback">
              Leave a Review! <GoTriangleRight />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  )
}
export const query = graphql`
  query {
    contact: markdownRemark(frontmatter: { title: { eq: "Contact" } }) {
      id
      html
      frontmatter {
        title
        heroImage {
          childImageSharp {
            fluid(maxWidth: 1080) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        meta {
          title
          description
          page_visible
        }
      }
    }
  }
`